import store from '../../store';
import { setCleanUser } from '../../store/ducks/auth/actions';

export default function logoff() {
  localStorage.removeItem('@token');
  store.dispatch(setCleanUser());
}
